import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { ActiveProcessModel } from "features/stock-ordering/core/domain/actove-process.model";
import {
  stockActiveProcessRepository,
  stockActiveProcessResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockActiveProcessState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockActiveProcessState;
  message: string;
  data: ActiveProcessModel | undefined;
}

const initialState: InitialState = {
  status: StockActiveProcessState.initial,
  message: "",
  data: undefined,
};

export const stockActiveProcess = createAsyncThunk(
  "stockActiveProcess",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: stockActiveProcessResponse =
        await stockActiveProcessRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockActiveProcessSlice = createSlice({
  name: "stockActiveProcess",
  initialState,
  reducers: {
    resetstockActiveProcessStatus: (state) => {
      state.status = StockActiveProcessState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockActiveProcess.pending, (state) => {
        state.status = StockActiveProcessState.inProgress;
      })
      .addCase(stockActiveProcess.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = StockActiveProcessState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(stockActiveProcess.rejected, (state, action) => {
        state.status = StockActiveProcessState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectStockActiveProcess = (state: RootState) =>
  state.stockActiveProcess;

export const { resetstockActiveProcessStatus } =
  stockActiveProcessSlice.actions;
export default stockActiveProcessSlice.reducer;
